import { ShopItem, TaxExemptionStatus } from 'store/shop';

export const getExemption = (item: ShopItem, country: string) =>
  item.taxExemptions.find((te) => te.country === country);

export const getExemptionStatus = (
  item: ShopItem,
  country: string,
): TaxExemptionStatus => getExemption(item, country)?.status ?? 'undefined';
